import React from "react";
import { NotificationContainer } from "./components/Notification/Index";
import { Routes as RoutedComponent } from "./routes/Routes";
import { useUser } from "./AuthContext";

/**
 * Responsible for rendering the App home component
 */
const AppHome = (): JSX.Element => {

  const { user } = useUser();

  if (user) {
    return (
      <>
        <RoutedComponent />
        <NotificationContainer />
      </>
    );
  }

  return <></>;
};

export default AppHome;
